import { render, staticRenderFns } from "./f-render.vue?vue&type=template&id=7b88ff44&"
import script from "./f-render.vue?vue&type=script&lang=js&"
export * from "./f-render.vue?vue&type=script&lang=js&"
import style0 from "./f-render.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports